/* global dvFrontendData */

/**
 * Open links in new tab, if:
 * - the link is not in the same domain
 * - the URL is not whitelisted
 */
const OuterLinks = async () => {
	// Get all gated links.
	const availableLinks = document.querySelectorAll('a[href]');
	if (!availableLinks.length) {
		return;
	}

	// Check if user is authenticated. Wait for the status to be resolved.
	if (window.DAVITA_AUTHENTICATED === 'pending') {
		const outerLinksInterval = setInterval(() => {
			if (window.DAVITA_AUTHENTICATED !== 'pending') {
				clearInterval(outerLinksInterval);
				OuterLinks();
			}
		}, 100);
	}

	// Each value is a string that must be included in the URL
	const whitelist = [
		dvFrontendData.currentBlogDomain,
		'network.davita.com',
		'entry.ewp.davita.com/logout',
	];

	availableLinks.forEach((link) => {
		// Normalize by removing protocol (http/https) before comparison
		const normalizedHref = link.href.replace(/^https?:\/\//, '');

		// Allow if href includes any of the whitelist strings
		const isWhitelisted = whitelist.some((rule) => normalizedHref.startsWith(rule));

		if (!isWhitelisted) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');
		}
	});
};

export default OuterLinks;
